import React from 'react';

// Helper function for metric icons
function getMetricIconText(icon) {
  const iconMap = {
    play: '▶',
    user: '👤',
    repeat: '🔄',
    clock: '🕒',
  };
  return iconMap[icon] || '📊';
}

function MetricCard({ title, value, change, changeType, icon, description }) {
  const isPositive = changeType === 'increase';

  return (
    <div className="card h-100" style={{ borderRadius: '8px' }}>
      <div className="card-body">
        <div className="d-flex flex-column" style={{ gap: '8px' }}>
          {/* Title Row */}
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                backgroundColor: '#e0e7ff',
                color: '#6366f1',
              }}
            >
              <span style={{ fontSize: '16px' }}>{getMetricIconText(icon)}</span>
            </div>
            <small className="text-muted">{title}</small>
          </div>

          {/* Value */}
          <h5 className="mb-0" style={{ fontWeight: 'bold' }}>
            {value}
          </h5>

          {/* Change Row */}
          <div className="d-flex align-items-center" style={{ gap: '8px' }}>
            <span
              className={`d-flex align-items-center ${isPositive ? 'text-success' : 'text-danger'}`}
              style={{ fontWeight: 500 }}
            >
              <span style={{ fontSize: '16px', marginRight: '2px' }}>{isPositive ? '↑' : '↓'}</span>
              {Math.abs(change)}%
            </span>
            <small className="text-muted">{description}</small>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MetricCard;
